export const baseApiUrl = "https://maveresiapi.technobrainent.co.za/";
